import * as React from 'react';

import styled, { css } from 'styled-components';
import ReactInputMask from 'react-input-mask';

import { defaultTheme } from "../theme";
import { omitProps } from "../helpers";

export const ErrorMessage = /*#__PURE__*/styled.span.withConfig({ displayName: "styles__ErrorMessage", componentId: "sc-1kdn79d-0" })(["display:inline-block;height:16px;margin-top:", ";color:#f44336;font-family:inherit;font-style:italic;font-weight:bold;line-height:normal;font-size:0.833em;letter-spacing:0.02em;"],


(props) => props.theme.spacers.M);









ErrorMessage.defaultProps = {
  theme: defaultTheme };


export const Label = /*#__PURE__*/styled(omitProps('active', 'theme')('span')).withConfig({ displayName: "styles__Label", componentId: "sc-1kdn79d-1" })(["position:absolute;top:", ";left:0;user-select:none;color:", ";height:12px;white-space:nowrap;transition:all 0.2s;transition-timing-function:cubic-bezier(0.4,0,0.2,1);pointer-events:none;", ""],

({ active }) => active ? '0px' : '18px',


(props) => props.theme.colors['Level 4'],






(props) => css(props.theme.typography.SmallCapsHeadline));


Label.defaultProps = {
  theme: defaultTheme };


export const Container = /*#__PURE__*/styled.label.withConfig({ displayName: "styles__Container", componentId: "sc-1kdn79d-2" })(["display:inline-block;position:relative;color:", ";", ""],


(props) => props.theme.colors.Foreground,

({ debug }) =>
debug &&
css(["&::after,&::before{content:'';display:block;position:absolute;box-sizing:border-box;width:48px;height:24px;background-color:tomato;border:1px solid;opacity:0.55;left:-1px;top:1px;}&::before{top:25px;}"]));





















Container.defaultProps = {
  theme: defaultTheme };


const InputComponent = ({ isMask, ...props }) => {
  if (isMask) {
    return /*#__PURE__*/React.createElement(ReactInputMask, props);
  }

  return /*#__PURE__*/React.createElement("input", props);
};






export const StyledInput = /*#__PURE__*/styled(omitProps('withIconRight', 'theme')(InputComponent)).withConfig({ displayName: "styles__StyledInput", componentId: "sc-1kdn79d-3" })(["", " line-height:18px;box-sizing:border-box;width:100%;padding:24px 0 6px;outline:none;background:transparent;border:none;border-bottom:2px solid ", ";color:inherit;", " &:focus ~ ", "{top:0px;}&:invalid,:-moz-submit-invalid,:-moz-ui-invalid{box-shadow:none;}&:disabled{color:", ";}"],
(props) => css(props.theme.typography.Paragraph),







(props) => props.theme.colors['Level 4'],


({ withIconRight }) =>
withIconRight &&
css(["padding-right:36px;"]),



Label,










(props) => props.theme.colors['Level 3']);



StyledInput.defaultProps = {
  theme: defaultTheme };


export const IconContainer = /*#__PURE__*/styled(omitProps('active')('span')).withConfig({ displayName: "styles__IconContainer", componentId: "sc-1kdn79d-4" })(["position:absolute;right:0;top:6px;padding:12px 0 0 12px;opacity:", ";cursor:pointer;outline:none;"],




({ active }) => active ? 1 : 0.65);